
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`၎င်းကို
                    <a href="${0}">Folksonomy Engine ပရောဂျက်</a>မှ ယူဆောင်လာခြင်းဖြစ်သည်။
                    ပါဝင်ရန် သို့မဟုတ် အကြံပြုချက်ပေးရန် မတွန့်ဆုတ်ပါနှင့်`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`ဤကိရိယာသည် ပါဝင်ပစ္စည်းများစာရင်းကို ပြုပြင်နိုင်စေပါသည်။
                ပါဝင်ပစ္စည်းများစာရင်းကို ထည့်သွင်းခြင်း၊ ဖယ်ရှားခြင်း သို့မဟုတ် တည်းဖြတ်နိုင်သည်။
                <br>
                ဤဇာတ်ကောင် <span class="highlight">␣</span> သည် နေရာလွတ်တစ်ခုကို ကိုယ်စားပြုသည်။
                <br>
                ဤဇာတ်ကောင် <span class="highlight">↩︎</span> သည် လိုင်းခွဲခြင်းကို ကိုယ်စားပြုသည်။ `,
'hb28f1f2ec1744ee9': html`ဤဂုဏ်သတ္တိများကို မည်သည့်အသုံးပြုမှုမျိုးအတွက်မဆို အသုံးပြုသူများက ဖန်တီးပြီး တင်ပြပါသည်။ သင့်ကိုယ်ပိုင်ထည့်ရန်
                    အခမဲ့ခံစားပါ။ သင်ဖန်တီးသည့် ဂုဏ်သတ္တိများနှင့် တန်ဖိုးများသည်
                    <strong>အဖြစ်မှန်ဖြစ်ရမည်</strong>။
                    <a href="${0}">အသိုင်းအဝိုင်းမှ အသုံးပြုပြီးသော ဂုဏ်သတ္တိများစာရင်း</a>
                    သို့မဟုတ်
                    <a href="${1}">ဂုဏ်သတ္တိများ စာရွက်စာတမ်းများနှင့် ၎င်း၏ ရှာဖွေရေးအင်ဂျင်</a>ကို ရှာဖွေနိုင်ပါသည်။`,
's000a5b76bd3a01c2': `ဂုဏ်သတ္တိများကို ဖွင့်နေသည်...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `ပါဝင်ပစ္စည်းများအတွက် ကျွန်ုပ်တို့ကိုကူညီပါ။`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `သီးနှံကို အတည်ပြုပါ။`,
's03e9c8114521b998': `ပါဝင်ပစ္စည်းတွေကို ပြင်ပါ့မယ်`,
's05ec315d9308091a': `ဘားကုဒ်ထောင့် သင်္ကေတ`,
's061eb5af92512c85': `သိမ်းဆည်းပြီး။ နောက်တစ်ယောက်နဲ့ ကူညီပေးနိုင်မလား။`,
's06847c221c4c0bc1': `[သင့်အသုံးပြုမှုကိစ္စဖော်ပြရန်] ပိုင်ဆိုင်မှုတစ်ခုဖန်တီးချင်ပါတယ်...`,
's06f6c6f99db6b552': `မူရင်း`,
's081e2ad82db71e1d': `အုပ်စုဖွဲ့တန်ဖိုးများ`,
's09205907b5b56cda': `မဟုတ္`,
's0b4235aae602a950': `သီးသန့်စာရွက်စာတမ်း`,
's0bb2d48532acc455': `CSV ကိုဒေါင်းလုဒ်လုပ်ပါ။`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `ပုံအား မမှန်ကန်ပါ။`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `ဖြတ်တောက်မှုကို ပယ်ဖျက်ပါ။`,
's11a18a69b30b65ed': `ပါဝင်ပစ္စည်းများစာရင်းတွင် အမှားအယွင်းများကို ကူညီပြင်ဆင်ပါ။`,
's1205d5f6fccf8e69': `အိမ်ခြံမြေတန်ဖိုး`,
's15d64a0a6715285a': `သော့အသစ်`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `ရွေးချယ်မှုဧရိယာ`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `အာဟာရဆိုင်ရာ အချက်အလက်များကို ပြုပြင်ရန် ကျွန်ုပ်တို့ကို ကူညီပေးပါ။`,
's1e00019dc454872d': `ကျေးဇူးပြု၍ ပိုင်ဆိုင်မှုအမည် ရည်ညွှန်းချက်ဖြင့် ပိုင်ဆိုင်မှုအမည်တစ်ခု ပေးပါ။`,
's1e49126af0935a5b': `ဤပိုင်ဆိုင်မှုကို အသုံးပြုထားသော ထုတ်ကုန်များစာရင်း`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `ပိုင်ဆိုင်မှုစာရွက်စာတမ်း`,
's300b3a6ee4e1252d': str`ညံ့ဖျင်းသောပွဲစဉ် ${0}%`,
's33f786bb6b4f0cf4': `သီးနှံရလဒ်`,
's33f85f24c0f5f008': `သိမ်းဆည်းမည်`,
's34be4af4e8fec4ae': `အသိုင်းအဝိုင်းကို အရင်မေးပါ။`,
's36d86adc823cbfa6': `ပစ္စည်းအသစ်မဖန်တီးမီ ၎င်းကို အသိုင်းအဝိုင်းနှင့် ဆွေးနွေးပါ-`,
's3781d25aa51a736c': `Folksonomy Engine Documentation`,
's383ae4449428b61e': `ဖြတ်တောက်မှုကို ပြန်လည်သတ်မှတ်ပါ။`,
's39bcf88721a1e8ee': `ရွေးချယ်မှုကို ပြန်လည်သတ်မှတ်ပါ။`,
's39e14e14300694c7': `စာရွက်စာတမ်းနှင့် လမ်းညွှန်ချက်များ`,
's3b430cfa5c1fe7f4': str`${0}အတွက် စာရွက်စာတမ်း`,
's3f4e4b52f230a892': `ပုံပတ္တူ`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `အလယ်ပုံ`,
's42dd66b2441566fd': `အလယ်ပုံလေး`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `ညာဘက်သို့ အရွယ်အစားပြောင်းပါ။`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `ထုတ်ကုန်အရေအတွက်`,
's4df2f533c0c1e7d0': `ရုပ်ပုံထိန်းချုပ်မှုများ`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `ရွေးချယ်မှုကို ရွှေ့ပါ။`,
's4f751fb9b3ed766c': `အိမ်ခြံမြေအသစ်ဖန်တီးခြင်း။`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `ပစ္စည်းအမည်ထည့်ပါ...`,
's55d7249883a98ca1': `Open Food Facts wiki တွင် ဤပိုင်ဆိုင်မှုအကြောင်း`,
's565867d84c04aea2': `စစ်ထုတ်ခြင်းဆိုင်ရာ ဂုဏ်သတ္တိများ...`,
's5666afe5cd0166de': `အတည်မပြုမီ အမှားများကို ပြင်ဆင်ပါ သို့မဟုတ် စာသားကို ပြင်ဆင်ပါ။`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `ထုတ်ကုန်များကို တင်နေသည်...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `အာဟာရဆိုင်ရာ အချက်အလက်များကို ပြုပြင်ရန် ကျွန်ုပ်တို့ကို ကူညီပေးပါ။`,
's5dd6f12783fca34f': `ပါဝင်ပစ္စည်းများစာရင်းကို တည်းဖြတ်ပါ။`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `ဖြတ်ထားသည့်ပုံ`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`ပွဲကောင်း ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `စာတမ်းပြုစုခြင်း။`,
's787dd11bed0dc88a': `ဘယ်ဘက်သို့ အရွယ်အစားပြောင်းပါ။`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `အိမ်ခြံမြေဖန်တီးမှုနှင့် လမ်းညွှန်ချက်များအကြောင်း ပိုမိုလေ့လာရန်-`,
's8038273de2cf8b73': `ဖြတ်တောက်ရန် ဒေသတစ်ခုကို ရွေးပါ။`,
's839cc2908a5387f2': `ဘားကုဒ်များကို စစ်ထုတ်ပါ...`,
's86197dcf3e96af64': `ရှိပြီးသားဂုဏ်သတ္တိများကို ရှာဖွေကြည့်ရှုပါ။`,
's8a63be30a129a59c': `အောက်ခြေကို အရွယ်အစားပြောင်းပါ။`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `အပေါ်ညာဘက်ကို အရွယ်အစားပြောင်းပါ။`,
's8db84aa4bc949af2': `ပစ္စည်းအသစ်ကို မှတ်တမ်းတင်ပါ။`,
's8f839a03997a16d7': `ထုတ်ကုန်ကိုကြည့်ပါ။`,
's901ae1e236ac45d3': `ပယ်ဖျက်ခြင်းအား ပယ်ဖျက်ပါ။`,
's907f7a97c6b29425': `ဒေတာမော်ဒယ်ကို ပြုပြင်နိုင်သည်ကို သတိထားပါ။ သင့်ကိုယ်ပိုင်စွန့်စားမှုကို အသုံးပြုပါ။`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `ပါဝင်ပစ္စည်းများ :`,
's9a7f60fce090ecaf': `ဂုဏ်သတ္တိများကို တင်ရန် မအောင်မြင်ပါ။ နောက်မှ ထပ်စမ်းကြည့်ပါ။`,
's9b87abd68fb9df45': `မတွေ့ဘူးလား။ သော့အသစ် {value}ဖန်တီးပါ။`,
's9c0f52425fd2f07e': `မယှဉ်နိုင်ပါ။`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `အမှတ်မရနိုင်ပါ။`,
'sa548778b24054030': `Folksonomy Engine ပရောဂျက်မှ ပံ့ပိုးပေးထားသော ဂုဏ်သတ္တိများအားလုံးကို စူးစမ်းပါ။ ဤဂုဏ်သတ္တိများသည် Open Food Facts ဒေတာဘေ့စ်ရှိ ထုတ်ကုန်များအကြောင်း နောက်ထပ် မက်တာဒေတာနှင့် ထိုးထွင်းအမြင်များကို ပေးဆောင်ပါသည်။`,
'sa63907958bd0ec4b': `ဘယ်ဘက်အပေါ်ကို အရွယ်အစားပြောင်းပါ။`,
'sa95b4224f685a36a': `မော်ဒယ်ပိတ်`,
'sab56a1d439576fd6': `အကြံပြုချက် သင်္ကေတ`,
'sac47ea2901d04c15': `ဘယ်ဘက်အောက်ခြေကို အရွယ်အစားပြောင်းပါ။`,
'sb125227d436c2925': `ရှိပြီးသား ဂုဏ်သတ္တိများဒေတာဘေ့စ်တွင် သင့်ပိုင်ဆိုင်မှုအယူအဆကို ရှာဖွေပါ-`,
'sb125568d43642e6f': `ထုတ်ကုန်နှင့်ပတ်သက်သောမေးခွန်းများကို ဖြေပါ။`,
'sb1c538e038f9b214': str`အရမ်းကောင်းတဲ့ပွဲ ${0}%`,
'sb28639570ff3b852': `ပိုင်ဆိုင်မှုအားလုံး၏စာရင်း`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `သင့်ပိုင်ဆိုင်မှုမရှိကြောင်း အတည်ပြုပြီး ၎င်းသည် အသုံးဝင်ကြောင်း အသိုင်းအဝိုင်းက သဘောတူပြီးသည်နှင့် ၎င်းကို ဝီကီတွင် ဦးစွာမှတ်တမ်းတင်ရန် လိုအပ်သည်။`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `ဤပိုင်ဆိုင်မှုအတွက် ထုတ်ကုန်မတွေ့ပါ။`,
'sb7f72e4c8a2d3357': `စစ်ထုတ်မှုတန်ဖိုးများ...`,
'sb8178320160f84ea': `ဖြတ်ညှပ်ကပ်ပြပါ။`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `ထိုးထွင်းသိမြင်မှုအားလုံးကို ဖြေပြီးပါပြီ။ ကူညီပေးမှုအတွက်ကျေးဇူးတင်ပါတယ်!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `သက်ဆိုင်သောတန်ဖိုး`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `အပေါ်ကို အရွယ်အစားပြောင်းပါ။`,
'sc1c08d0cbcc3bd24': `မကိုက်ညီပါ။`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `ပြင်ဆင်ရန် အကြံပြုထားသည်။`,
'sc681b137e8f604f7': `ဖျက်ခြင်းကို အတည်ပြုပါ`,
'sc6daf8a31883f8b9': `ပုံကိုရွှေ့ပါ။`,
'sc895972c88d38ca5': `Folksonomy ပစ္စည်းဥစ္စာ`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `အတန်းလိုက်`,
'scb3b0671d7b7f640': `တန်ဖိုးအသစ်`,
'scb489a1a173ac3f0': `ဟုတ္`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Slack Discussion တွင် ပါဝင်ပါ။`,
'scdb6cad0b92721bf': `ပိုင်ဆိုင်မှု မတွေ့ပါ။`,
'scf23a05631f93732': `ဖျက်ရန် အတည်ပြုပါ။`,
'scfed2f270ef6a3aa': `ဧရိယာကိုရွေးချယ်ပါ။`,
'sd1022bc1ef9204f7': `ချဲ့နိုင်သောပုံ`,
'sd1077c055cf9ba6b': `ထုတ်ကုန်၏ ပါဝင်ပစ္စည်းစာရင်းကို အတည်ပြုရန် ကျွန်ုပ်တို့ကို ကူညီပေးပါ။`,
'sd698d21ddecba56b': `ဟေး! အောက်ဖော်ပြပါ အစိတ်အပိုင်းများကို ဖြေကြားခြင်းဖြင့် ထုတ်ကုန်အချက်အလက် ပိုမိုကောင်းမွန်အောင် ကျွန်ုပ်တို့အား ကူညီနိုင်သည်-`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `ပစ္စည်းတစ်ခု ရှိနှင့်ပြီးပြီလား၊ စစ်ဆေးပါ။`,
'sdbf806fefc584115': `တစ်ခုရှာသင့်တယ်။`,
'sdc673e73b5c13aea': `ဖ်က္မည္`,
'sdc792b75f1edcaba': `ပါဝင်ပစ္စည်းများ၏ စာလုံးပေါင်းကို ပြုပြင်ရန် ကျွန်ုပ်တို့ကို ကူညီပေးပါ။`,
'sdca5deead576ceee': `အောက်ခြေညာဘက်ကို အရွယ်အစားပြောင်းပါ။`,
'sdcc2555c5dde524f': `ဤအရာကို ဖျက်လိုသည်မှာ သေချာပါသလား။ ဤလုပ်ဆောင်ချက်ကို ပြန်ပြင်၍မရပါ။`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `မမှန်ပါ။`,
'se5127cf0f92e7e48': `အကြံပြုချက်- သင်လည်း ရှာတွေ့နိုင်ပါသည်။`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `ပိုကောင်းတဲ့သီးနှံကို အဆိုပြုမယ်။`,
'seea3800e27baa686': `တစ်ဦးချင်း ထုတ်ကုန်များ`,
'sefaba4adc4ec9219': `Folksonomy ဂုဏ်သတ္တိများ`,
'seffa8ca49175b5f0': `စိတ်ကြိုက်ဖြစ်တတ်ပါတယ်။`,
'sf44a6b3b232c28ea': str`လက်ရှိတန်ဖိုးကို ${0}ဖြင့် အစားထိုးပါ။`,
'sf4cd86a2f5ef2588': `ထုတ်ကုန်ဘားကုဒ်`,
'sf57a61152168cc81': `ပါဝင်ပစ္စည်းရှာဖွေတွေ့ရှိမှုကို ပြုပြင်ရန် ကျွန်ုပ်တို့ကို ကူညီပေးပါ။`,
'sf88b90b8ba23871c': `အမည်မသိပွဲစဉ်`,
'sf9aee319a006c9b4': `ပေါင်းထည့်သည်/ပါ။`,
'sfacbbe968fa7d773': `အိမ်ခြံမြေ အမည်-`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `သက်ဆိုင်သောတန်ဖိုး`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  